import gql from "graphql-tag";

const searchQuery = gql`
    query SearchQuery($text: String!, $language: String!, $instance: String!){
        search(text: $text, language: $language, instance: $instance)
    }
`;

export default searchQuery;